// extracted by mini-css-extract-plugin
export default {"tarjeta_ultimos":"TarjetaUltimos_tarjeta_ultimos__ZIAwK"};